












import { defineComponent } from "vue";

export default defineComponent({
  inheritAttrs: true,
  props: {
    p: {
      type: String || Number,
      required: false,
      default: "16px"
    },
    mt: {
      type: String || Number,
      required: false,
      default: "16px"
    },
    mb: {
      type: String || Number,
      required: false,
      default: "16px"
    }
  }
});
